import type { AssetStatus, ReleaseAsset } from "@/lib/api";

export const REPOS = ["denkboxgmbh/dbui", "denkboxgmbh/denkbOS"];

export function statusVariant(
  status: AssetStatus,
): "default" | "secondary" | "destructive" | "outline" {
  switch (status) {
    case "downloaded":
      return "default";
    case "downloading":
      return "outline";
    case "failed":
      return "destructive";
    default:
      return "secondary";
  }
}

export function formatReleaseDate(published_at: string | null): string {
  if (!published_at) return "—";
  return new Date(published_at).toLocaleDateString();
}

/** Worst-case status across a release's assets, for a single compact badge. */
export function worstAssetStatus(assets: ReleaseAsset[]): AssetStatus {
  if (assets.length === 0) return "pending";
  if (assets.some((a) => a.status === "failed")) return "failed";
  if (assets.some((a) => a.status === "downloading")) return "downloading";
  if (assets.every((a) => a.status === "downloaded")) return "downloaded";
  return "pending";
}
